import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { templateEmployeeViewHeader } from "pages/HR/Headers";
import { Loader } from "components/Loader";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { stickyHeader } from "services/constants";
import { tableRowSize } from "services/constants";
import { drawerStyle } from "services/constants";
import { Drawer } from "@mui/material";
import { ViewUserTemplateScreen } from "../ViewUserTemplateScreen";

export const SalaryComponentEmployeeView = ({
  userComponentDetails,
  setUserComponentDetails,
  setUserComponentData,
  page,
  setPage,
}) => {
  const { domain, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const {
    result: userComponentData,
    loading,
    setLoad: reCallApi,
  } = useFetch(
    `${domain}hrzone/salary/salary_template/users-template/?company_id=${topbarCompanyId}`
  );
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const containerRef = useRef(null);
  const [userData, setUserData] = useState({});

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (userComponentData?.users?.length !== 0 && userComponentData) {
      setUserComponentDetails(userComponentData?.users);
      setUserComponentData(userComponentData?.users);
    }
  }, [setUserComponentData, setUserComponentDetails, userComponentData]);

  const handleViewComponent = () => {
    setIsViewPanelOpen(true);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
  };

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Mui.Grid
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mr: 2,
        }}
      >
        <Mui.Typography sx={{ fontWeight: 600 }}>
          Total Number of Employee :{" "}
          {userComponentDetails
            ? new Set(userComponentDetails.map((item) => item.user_id)).size
            : 0}
        </Mui.Typography>
      </Mui.Grid>
      {loading ? (
        <Loader />
      ) : (
        <Mui.Grid>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ mt: 2, width: "100%", ml: 2, mr: 2, maxHeight: 520 }}
            id="Shift_grade_table"
          >
            <Mui.Table className="border">
              <Mui.TableHead sx={stickyHeader}>
                <Mui.TableRow sx={tableRowSize}>
                  {templateEmployeeViewHeader?.map((head) => (
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      {head.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {userComponentDetails?.length === 0 && !loading ? (
                  <InfoMessage dataLength={userComponentData?.users} />
                ) : (
                  userComponentDetails
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((user) => (
                      <React.Fragment>
                        <Mui.TableRow sx={tableRowSize}>
                          {templateEmployeeViewHeader?.map((head) => (
                            <Mui.TableCell
                              key={head.key}
                              onClick={() => {
                                handleViewComponent();
                                setUserData(user);
                              }}
                            >
                              {head.key === "employee_name" ? (
                                <Mui.Stack direction="row" alignItems="center">
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={user?.employee_name
                                      ?.charAt(0)
                                      ?.toUpperCase()}
                                    src={user?.image_url || optionalAvathar}
                                  />
                                  &nbsp;{user?.employee_name}
                                </Mui.Stack>
                              ) : user[head.key] ? (
                                user[head.key]
                              ) : (
                                "N/A"
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      </React.Fragment>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          {userComponentDetails?.length > 25 && (
            <Mui.Box sx={{ mt: 1 }}>
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={userComponentDetails?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Mui.Box>
          )}
        </Mui.Grid>
      )}

      <Drawer
        anchor="right"
        open={isViewPanelOpen}
        onClose={() => {
          handleViewClosePanel();
        }}
        sx={drawerStyle}
      >
        <ViewUserTemplateScreen
          onClose={handleViewClosePanel}
          userData={userData}
        />
      </Drawer>
    </React.Fragment>
  );
};
